// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container___0S5a","insightsList":"newBusinessInsightsMenu_insightsList__1L8JQ","active":"newBusinessInsightsMenu_active__2E1hh"};